import React, { Dispatch, SetStateAction } from "react";
import Navigator from '../components/Navigation';
import { ArticleTextSection } from "../articleDetailPage/ArticleTextSection"
import { ProtectedArticleGroup } from "../articleDetailPage/ProtectedArticleGroup";
import { ArticleTitle } from "../articleDetailPage/ArticleTitle";
import { hashPasswordsFromEnv } from "../utils/passwordUtils";
import ArticleImageLayout from "../articleDetailPage/ArticleImageLayout";
import '../style.css';
import { Wavedivider } from "../components/Wavedivider";
import { CalloutLink } from "../components/CalloutLink";
import { useMetaTags } from '../utils/useMetaTags';
import ProtectedPage from "../components/ProtectedPage";
import img1 from '../image/articles/히로시마/IMG_3146.webp';
import img2 from '../image/articles/히로시마/IMG_3150.webp';
import img3 from '../image/articles/히로시마/IMG_3152.webp';
import img4 from '../image/articles/히로시마/IMG_3170.webp';
import img5 from '../image/articles/히로시마/IMG_3172.webp';
import img6 from '../image/articles/히로시마/IMG_3176.webp';
import img7 from '../image/articles/히로시마/IMG_3193.webp';
import img8 from '../image/articles/히로시마/IMG_3194.webp';
import img9 from '../image/articles/히로시마/IMG_3196.webp';
import img10 from '../image/articles/히로시마/IMG_3199.webp';
import img11 from '../image/articles/히로시마/IMG_3205.webp';
import img12 from '../image/articles/히로시마/IMG_3210.webp';
import img13 from '../image/articles/히로시마/IMG_3214.webp';
import img14 from '../image/articles/히로시마/IMG_3217.webp';
import img15 from '../image/articles/히로시마/IMG_3219.webp';
import img16 from '../image/articles/히로시마/IMG_3221.webp';
import img17 from '../image/articles/히로시마/IMG_3222.webp';
import img18 from '../image/articles/히로시마/IMG_3226.webp';
import img19 from '../image/articles/히로시마/IMG_3231.webp';
import img20 from '../image/articles/히로시마/IMG_3238.webp';
import img21 from '../image/articles/히로시마/IMG_3240.webp';
import img22 from '../image/articles/히로시마/IMG_3246.webp';
import img23 from '../image/articles/히로시마/IMG_3247.webp';
import img24 from '../image/articles/히로시마/IMG_3250.webp';
import img25 from '../image/articles/히로시마/IMG_3252.webp';
import img26 from '../image/articles/히로시마/IMG_3255.webp';
import img27 from '../image/articles/히로시마/IMG_3256.webp';
import img28 from '../image/articles/히로시마/IMG_3257.webp';
import img29 from '../image/articles/히로시마/IMG_3259.webp';
import img30 from '../image/articles/히로시마/IMG_3262.webp';
import img31 from '../image/articles/히로시마/IMG_3264.webp';
import img32 from '../image/articles/히로시마/IMG_3265.webp';
import img33 from '../image/articles/히로시마/IMG_3266.webp';
import img34 from '../image/articles/히로시마/IMG_3267.webp';
import img35 from '../image/articles/히로시마/IMG_3268.webp';
import img36 from '../image/articles/히로시마/IMG_3269.webp';

const images1 = [
  img1,
];

function Essay2606_hirosima(props: {
    activeNav: number, 
    setActiveNav: Dispatch<SetStateAction<number>>,
  }) {
   
      
      const hashedPasswords = hashPasswordsFromEnv(
        process.env.REACT_APP_ESSAY2606_PASSWORDS
      );
    
      useMetaTags({
        title: '여행기록 - Lynkim',
        description: '히로시마',
        image: '/ogimage.png',
      });
      
      return (
        <>
        {/* <ProtectedPage password={hashedPasswords} description="이 페이지의 비밀번호는 개인번호로 설정되어 있어요"> */}
        <Navigator activeNav={props.activeNav} setActiveNav={props.setActiveNav} />
        <div className='fadeIn '>
            <ArticleTitle
                title={'여행기록'}
                titleEn={'Travel Journal'}
                description={<div>히로시마</div>}
                category={'essay'}
                date={'2026.06.07.'}
                thumbnail={img1}
            />
        </div>
        <Wavedivider/>
        <div className='articleLayout'>

            <ArticleTextSection
                title='몰래 떠나기'
                titleEn='Slipping Away'
                marginBottom={true}
                marginTop={true}
                description={<div>

                    </div>} />

            
        </div>
        {/* </ProtectedPage> */}
        </>
      )
  }

export default Essay2606_hirosima;